import * as yup from 'yup'
import { parse, setHours } from 'date-fns'

import * as validationKeys from './constants'
import {
  PASSWORD_REGEX,
  ZIP_CODE_REGEX,
  PHONE_NUMBER_REGEX,
  normalizeNID,
  validateCIF,
  validateNIFNIE,
  validateUrl
} from './validations'

const isAbsent = v => v == null

/** yup override locale messages with app keys
 * @see {@link https://github.com/jquense/yup/blob/master/src/locale.js}
 */
yup.setLocale({
  mixed: {
    required: validationKeys.REQUIRED,
    oneOf: validationKeys.REQUIRED,
    notType: ({ type }) => (type === 'date')
      ? validationKeys.IS_VALID_DATE
      : validationKeys.REQUIRED
  },
  string: {
    email: validationKeys.EMAIL,
    url: validationKeys.URL
  },
  number: {
    min: validationKeys.MIN_NUMBER
  },
  date: {
    max: validationKeys.MAX_DATE
  }
})

// string methods

// yup.string().password()
yup.addMethod(yup.string, 'password', function password(message = validationKeys.PASSWORD) {
  return this.matches(PASSWORD_REGEX, message)
})

// yup.string().zipCode()
yup.addMethod(yup.string, 'zipCode', function zipCode(message = validationKeys.ZIP_CODE) {
  return this.matches(ZIP_CODE_REGEX, message)
})

// yup.string().phoneNumber()
yup.addMethod(yup.string, 'phoneNumber', function phone(message = validationKeys.PHONE_NUMBER) {
  return this.matches(PHONE_NUMBER_REGEX, message)
})

// yup.string().cif()
yup.addMethod(yup.string, 'cif', function cif(message = validationKeys.CIF) {
  return this.transform(normalizeNID)
    .test({
      message,
      name: 'cif',
      exclusive: true,
      test: value => isAbsent(value) || validateCIF(value)
    })
})

// yup.string().nifNie()
yup.addMethod(yup.string, 'nifNie', function nifNie(message = validationKeys.NIF_NIE) {
  return this.transform(normalizeNID)
    .test({
      message,
      name: 'nifNie',
      exclusive: true,
      test: value => isAbsent(value) || validateNIFNIE(value)
    })
})

yup.addMethod(yup.string, 'nifCif', function cif(message = validationKeys.CIF) {
  return this.transform(normalizeNID)
    .test({
      message,
      name: 'nifCif',
      exclusive: true,
      test: value => isAbsent(value) || validateCIF(value) ||validateNIFNIE(value)
    })
})

yup.addMethod(yup.string, 'validUrl', function validUrl(message = validationKeys.URL) {
  return this.transform(normalizeNID)
    .test({
      message,
      name: 'validUrl',
      exclusive: true,
      test: value => isAbsent(value) || validateUrl(value)
    })
})

// bool methods

// yup.bool().isTrue()
yup.addMethod(yup.bool, 'isTrue', function isTrue(message = validationKeys.IS_TRUE) {
  return this.test({
    message,
    name: 'isTrue',
    exclusive: true,
    test: value => value === true
  })
})

// yup.bool().isFalse()
yup.addMethod(yup.bool, 'isFalse', function isFalse(message = validationKeys.IS_FALSE) {
  return this.test({
    message,
    name: 'isFalse',
    exclusive: true,
    test: value => value === false
  })
})

// date methods

// yup.date().format([format])
yup.addMethod(yup.date, 'format', function isValid(format) {
  return this.transform((value, original) => setHours(parse(original, format, new Date()), 12))
})
